import type { Address, PublicClient } from 'viem';

import { wAlphaAbi } from 'libs/contracts/abis/bittensorWrappers';

// Live read of the Bittensor wrapper's `exchangeRate()` view.
//
// Semantics: the rate is "native base units per 1e18 wrapper shares" and
// grows as the wrapper accrues staking yield (wAlpha: 9-dec RAO/1e18, wsTAO:
// 18-dec wei/1e18). Both wrapper ABIs share an identical selector for this
// view, so wAlphaAbi resolves correctly against either wrapper kind.
//
// SupplyForm uses the rate to scale projected-supply native input down to
// its wrapper-equivalent before feeding the bundled-openPosition simulation;
// without it, projected collateral is overstated by the appreciation factor.
export const getWrapperExchangeRate = async ({
  publicClient,
  wrapperAddress,
}: {
  publicClient: PublicClient;
  wrapperAddress: Address;
}): Promise<bigint> =>
  publicClient.readContract({
    address: wrapperAddress,
    abi: wAlphaAbi,
    functionName: 'exchangeRate',
  });
